<template>
  <div class="fader">
    <flickity
      class="slides"
      ref="flickity"
      :options="flickityOptions"
    >
      <FadeItem
        v-for="(item, index) in items"
        :key="index"
        :src="item"
      ></FadeItem>
    </flickity>
  </div>
</template>

<script>
import media from '@/utils/media'
import { mediaQueryMixin } from '@/mixins'
import Flickity from 'vue-flickity'
import FadeItem from './FadeItem'

export default {
  name: 'Fader',
  data () {
    return {
      flickityOptions: {
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        imagesLoaded: true,
        autoPlay: 2500,
        pauseAutoPlayOnHover: false,
        accessibility: false,
        draggable: false
      }
    }
  },
  mixins: [mediaQueryMixin],
  computed: {
    items () {
      const size = this.mobile ? 'mobile' : 'desktop'
      return media.intro.fader[size]
    }
  },
  components: {
    Flickity,
    FadeItem
  }
}
</script>

<style lang="scss" scoped>
</style>
<style lang="scss">
.fader {
  pointer-events: none;
  margin-bottom: 40px;
  .flickity-slider {
    transform: none !important;
  }
  .fade-item {
    left: 0 !important;
    opacity: 0;
    transition: opacity 1s ease-in-out;
    z-index: 1;

    &.is-selected {
      opacity: 1;
      z-index: 2;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/fader/Fader.vue